"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1728))
 * @lastsynced 2026-10-29T13:54:59.986Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Synchronized = createSVGIcon(
  <path
    d="m23.143 18-.857-3.429-3.429.858m3.429-.858A11.6 11.6 0 0 1 12 22.286a10.32 10.32 0 0 1-9.663-6.772M.857 6l.857 3.429 3.429-.858m-3.429.858C3.158 5.486 7.575 1.714 12 1.714a10.32 10.32 0 0 1 9.664 6.772"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Synchronized",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
